// @format
export default {
  RED: 'rgb(149, 26, 47)',
  GRAYBLUE: '#4d5c5e',
};
